import { RemoveGuestFromRoomActionTypes, RemoveGuestFromRoomState, REMOVE_GUEST_FROM_ROOM_FAILURE, REMOVE_GUEST_FROM_ROOM_REQUEST, REMOVE_GUEST_FROM_ROOM_SUCCESS } from "./types";

const defaultState: RemoveGuestFromRoomState = {
  isLoading: false,
  errorMessage: ""
};

export default function removeGuestFromRoom(state = defaultState, action: RemoveGuestFromRoomActionTypes): RemoveGuestFromRoomState {
  switch (action.type) {
    case REMOVE_GUEST_FROM_ROOM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case REMOVE_GUEST_FROM_ROOM_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case REMOVE_GUEST_FROM_ROOM_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};